import { App, Button, Card, Col, Input, message, Modal, Upload, Pagination, Row, Select, Space, Spin, Table, Tag, Popconfirm, Tooltip, Switch, Popover } from "antd";
import { EyeFilled, LoadingOutlined, UploadOutlined, BookOutlined, LockOutlined, CloseOutlined, CheckOutlined, DownloadOutlined, CloudDownloadOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BULD_ADD_LEARNERS, LEARNER_LIST, LEARNER_STATUS, CHANGE_LEARNER_PASSWORD, BULD_ADD_LEARNER_TEMPLATE, ASSIGN_SUBADMIN_AS_LEARNER } from "../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import { formatToIST } from "../../../helper/CommonHelper";



function Learners() {
  const { notification } = App.useApp();
  const [page_size, set_page_size] = useState(10);
  //USE STATE FOR PAGINATION AND LOADER
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState(false);
  const [current_page, set_current_page] = useState("");
  const [total_pages, set_total_pages] = useState("");
  const [total_learners, set_total_learners] = useState("");
  const [onchange_call, set_onchange_call] = useState(true);
  const [errors, set_errors] = useState("");
  // fillter state
  const [placeholder, set_placeholder] = useState("Search by name");
  const [search_query_key, set_search_query_key] = useState('name');
  const [search_query_value, set_search_query_value] = useState('');
  const [file, set_file] = useState([]);
  const [is_model_open, set_is_model_open] = useState(false);


  // ✅ CHANGE PASSWORD STATES
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [passwordEmail, setPasswordEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState({});




  const handleUpdatePassword = async () => {
    setPasswordErrors({});

    try {
      setPasswordLoading(true);

      const formData = new FormData();
      formData.append("email", passwordEmail);
      formData.append("new_password", newPassword);
      formData.append("confirm_password", confirmPassword);

      const response = await CHANGE_LEARNER_PASSWORD(formData);

      if (response?.data?.status) {
        notification.success({
          message: "Success",
          description: response.data.message,
        });

        setChangePasswordModal(false);
        setNewPassword("");
        setConfirmPassword("");
        setPasswordErrors({});
      } else {
        // ✅ status false but 200 response
        setPasswordErrors(response?.data?.errors || {});
      }
    } catch (error) {
      // ✅ 400 / 422 backend validation
      if (error?.response?.data?.errors) {
        setPasswordErrors(error.response.data.errors);
      } else {
        notification.error({
          message: "Server Error",
          description: "Something went wrong",
        });
      }
    } finally {
      setPasswordLoading(false);
    }
  };





  const handleDownloadTemplate = async () => {
    try {
      const response = await BULD_ADD_LEARNER_TEMPLATE();

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "bulk_add_learners_template.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();

      notification.success({
        message: "Template Downloaded",
        description: "Excel template downloaded successfully",
      });
    } catch (error) {
      notification.error({
        message: "Download Failed",
        description: "Something went wrong",
      });
    }
  };




  const showModal = () => {
    set_is_model_open(true);
  };


  const handleCancel = () => {
    set_is_model_open(false);
  };

  const beforeUpload = (file) => {
    const isCSV = file.type === 'text/csv';
    if (!isCSV) {

      return Upload.LIST_IGNORE;
    }

    set_file([file]);
    message.success(` ${file.name}`);
    return false;
  };


  const fetchResults = useCallback((search_key, search_value) => {
    debounce(async () => {
      try {
        set_pagination_loader(true);
        const FORM_DATA = new FormData();
        FORM_DATA.append(search_key, search_value);
        const API_CALL = await LEARNER_LIST(FORM_DATA);
        if (API_CALL?.data?.status) {
          set_table_data(API_CALL?.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_learners(API_CALL?.data?.total_learners);
        }
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        set_pagination_loader(false);
      }
    }, 500)(); // Call debounce immediately
  }, []);



  const LIST_API = async () => {
    const FORM_DATA = new FormData();
    const API_CALL = await LEARNER_LIST(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_learners(API_CALL?.data?.total_learners);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  useEffect(() => {
    LIST_API();
  }, [onchange_call]);

  const change_status = async (id) => {
    setLoader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);
    try {
      const response = await LEARNER_STATUS(FORM_DATA);
      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });
        set_onchange_call(onchange_call ? false : true)

      } else {
        // setLoader(false);

      }
    } catch (error) {
      message.error(
        "Server Error: " + (error?.response?.data?.message || "Unknown error")
      );
    }
  };

  const selectBefore = (
    <Select defaultValue="Name" onChange={(value) => {
      if (value === 'Name') {
        set_search_query_key('name')
        set_placeholder("Search by name");
        fetchResults('name', search_query_value)
      }
      if (value === 'Email') {
        set_search_query_key('email')
        set_placeholder("Search by email");
        fetchResults('email', search_query_value)
      }
      // if (value === 'Phone') {
      //   set_search_query_key('contact_no')
      //   set_placeholder("Search by contact no.");
      //   fetchResults('contact_no', search_query_value)
      // }
    }}>
      <Select.Option value="Name">Name</Select.Option>
      <Select.Option value="Email">Email</Select.Option>
      {/* <Select.Option value="Phone">Phone</Select.Option> */}
    </Select>
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span>
          {record.first_name} {record.last_name}
        </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text, record) => <span>{record.email}</span>,
    },
    // {
    //   title: "Phone",
    //   dataIndex: "contact_no",
    //   render: (text, record) => <span>{record.contact_no}</span>,
    // },
    {
      title: "Role",
      dataIndex: "role",
      render: (text, record) => <span>{record.role === 'sub_admin' ? 'Sub Admin' : 'learner'}</span>,
    },
    {
      title: "Last Login",
      dataIndex: "last_login",
      render: (text, record) => (
        <div>
          {record.last_login ? <>
            <div style={{ fontSize: "12px", }}>{formatToIST(record.last_login)}</div>

          </> : <><div style={{ color: "red" }}>No Activity</div></>}

        </div>
      ),
    },
    {
      title: "Joined On",
      key: "joining_on",
      render: (text, record) => (
        <div>
          <div style={{ fontSize: "12px" }}>{formatToIST(record.joining_on)}</div>

        </div>
      ),
    },
    {
      title: "Status",
      key: "status",
      render: (text, record) => (
        <Popconfirm
          title="Do you want to change the status?"
          onConfirm={() => change_status(record?.id)}
          okText="Yes"
          cancelText="No"
        >
          <Tag style={{cursor:"pointer"}} color={record.status ? "success" : "error"}>
            {record.status ? "Active" : "Inactive"}
          </Tag>
        </Popconfirm>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Popover
            content="You can't view Sub Admin details"
            trigger={record.role === "sub_admin" ? "hover" : ""}
          >
            <Button
              type="primary"
              size="small"
              disabled={record.role === "sub_admin"}
              onClick={() => navigate("/edit-learner/" + btoa(record.id))}
            >
              <EyeFilled />
            </Button>
          </Popover>
          <Tooltip title=" Learner Courses">
            <Button type="primary" size="small" onClick={() => navigate(`/learner-courses/${record.id}`)}><BookOutlined /></Button></Tooltip>
          {/* <Tooltip title="Change Password">
            <Button
              size="small"
              onClick={() => {
                setPasswordEmail(record.email);
                setChangePasswordModal(true);
              }}
              style={{ backgroundColor: 'green', borderColor: 'green', color: 'white' }}
            >
              <LockOutlined />
            </Button>
          </Tooltip>*/}
{/* 
          <Popconfirm
            title="Do you want to change the status?"
            onConfirm={() => change_status(record?.id)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Change Status">
              <Button
                size="small"
                style={{
                  backgroundColor: record.status ? "#52c41a" : "#ff4d4f",
                  borderColor: record.status ? "#52c41a" : "#ff4d4f",
                  color: "#fff"
                }}
                icon={
                  record.status ? (
                    <CheckOutlined />
                  ) : (
                    <CloseOutlined />
                  )
                }
              />
            </Tooltip>
          </Popconfirm> */}


          <Popconfirm
            title="Are you sure you want to change this Learner to a Sub Admin?"
            onConfirm={() =>
              assignSubAdminAsLearner(
                record.id,
                record.role === "sub_admin" ? 0 : 1
              )
            }
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Learner to sub admin">
              <Switch
                size="large"
                checked={record.role === "sub_admin"}
                checkedChildren={"S"}
                unCheckedChildren={"L"}
                style={{
                  backgroundColor: record.role === "sub_admin" ? "#52c41a" : "#ff4d4f"
                }}
              />
            </Tooltip>
          </Popconfirm>

        </Space>
      ),
    },
  ];

  const assignSubAdminAsLearner = async (id, learnerStatus) => {
    try {
      setLoader(true);

      const FORM_DATA = new FormData();
      FORM_DATA.append("id", id);
      FORM_DATA.append("learner", learnerStatus); // 0 or 1

      const response = await ASSIGN_SUBADMIN_AS_LEARNER(FORM_DATA);

      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });

        // refresh list
        set_onchange_call(prev => !prev);
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message || "Something went wrong",
        });
      }
    } catch (error) {
      notification.error({
        message: "Server Error",
        description: error?.response?.data?.message || "Unknown error",
      });
    } finally {
      setLoader(false);
    }
  };


  const pagination_on_change = async (page, size) => {
    set_pagination_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", size);
    FORM_DATA.append(search_query_key, search_query_value);
    const API_CALL = await LEARNER_LIST(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_learners(API_CALL?.data?.total_learners);
      set_pagination_loader(false);
    } else {
      set_pagination_loader(false);
    }
  }

  const handleInput = (e) => {
    const value = e.target.value;
    set_search_query_value(value)

    if (search_query_key === 'name') {
      fetchResults('name', value)
    }
    if (search_query_key === 'email') {
      fetchResults('email', value)
    }
    if (search_query_key === 'contact_no') {
      fetchResults('contact_no', value)
    }
  };


  const handleBulkUpload = async () => {
    if (!file.length) {
      message.error("Please upload a CSV file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file[0]);

    try {
      const response = await BULD_ADD_LEARNERS(formData);

      if (response?.data?.status) {

        //  SUCCESS MESSAGE
        notification.success({
          message: "Success",
          description: response?.data?.message || "Learners imported successfully",
          placement: "topRight",
        });


        set_is_model_open(false);


        set_file([]);
        set_errors("");


        LIST_API();

      } else {
        set_errors(response?.data?.errors || {});
        message.error("Import failed");
      }
    } catch (error) {
      message.error(
        "Server Error: " + (error?.response?.data?.message || "Unknown error")
      );
    }
  };


  return (
    <div className="lms-body">
      <Card className="card-bg">
        <Row>
          <Col span={12}>
            <h2>Learners / Sub Admin</h2>
          </Col>
          <Col span={12}>
            <div className="learner-buttons" style={{ float: "right" }}>
              <Button
                color="green"
                variant="solid"
                onClick={handleDownloadTemplate}
                icon={<DownloadOutlined />}
                style={{ marginRight: "10px" }}
              >
                Download Template
              </Button>
              <Button
                type="primary"
                variant="solid"
                style={{ marginRight: "10px" }}
                onClick={() => navigate("/add-learner")}
              >
                Add Learner
              </Button>
              <Button
                color="green"
                variant="solid"
                style={{ marginRight: "10px" }}
                onClick={showModal} onCancel={handleCancel}
              >
                Import Learners
              </Button>
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Input
              addonBefore={selectBefore}
              placeholder={placeholder}
              onChange={handleInput}
              size="large"
            />
          </Col>
        </Row>

        {loader ? (
          <>
            <CulsightPageLoader />
          </>
        ) : (
          <>
            {pagination_loader ? (
              <>
                <div style={{ textAlign: "center", padding: "60px" }}>
                  <Spin indicator={<LoadingOutlined spin />} size="large" />
                </div>
              </>
            ) : (
              <>
                <Table
                  columns={columns}
                  pagination={false}
                  dataSource={table_data}
                  style={{ marginTop: "15px" }}
                  rowKey="id"
                />
              </>
            )}

            {total_pages > 0 ? (
              <>
                <div style={{ float: "right", marginTop: "20px" }}>
                  {" "}
                  <Pagination
                    current={current_page}
                    total={total_learners}
                    pageSize={page_size}
                    showSizeChanger
                    pageSizeOptions={['10', '20', '50', '100']}
                    onChange={(page) => pagination_on_change(page, page_size)}
                    onShowSizeChange={(page, size) => {
                      set_page_size(size);
                      pagination_on_change(1, size);
                    }}
                    style={{ display: 'inline-block' }}
                    className="no-search-pagination"
                  />

                  <style>
                    {`
    .no-search-pagination .ant-select-selection-search-input {
      display: none !important;
    }
  `}
                  </style>
                </div>
              </>
            ) : (
              <>
                <div style={{ textAlign: "center", color: "red" }}>
                  <h2>No Learner Found</h2>
                </div>
              </>
            )}
          </>
        )}



        <Modal
          title="Import Users"
          open={is_model_open}
          onCancel={handleCancel}
          footer={[
            <Button color="green" variant="solid" onClick={handleBulkUpload} style={{ width: "100%" }}>
              Add
            </Button>,
          ]}
          width={400}
        >
          <div style={{ width: "100%" }}>
            <Upload
              beforeUpload={beforeUpload}
              fileList={file}
              maxCount={1}
              multiple={false}
              onRemove={() => set_file([])}
              accept=".csv"
              style={{ width: "100%" }}
            >
              <div style={{ width: "100%" }}>
                <Button type="primary" icon={<UploadOutlined />} block>
                  Upload File
                </Button>
              </div>
            </Upload>
            {errors?.file ? (
              <>
                <span style={{ color: "red" }}>
                  {errors?.file}
                </span>
              </>
            ) : (
              <></>
            )}
          </div>
        </Modal>
        <Modal
          title="Change Password"
          open={changePasswordModal}
          onCancel={() => {
            setChangePasswordModal(false);
            setNewPassword("");
            setConfirmPassword("");
            setPasswordErrors({});
          }}
          footer={[
            <Button
              type="primary"
              loading={passwordLoading}
              onClick={handleUpdatePassword}
              style={{ width: "100%" }}
            >
              Update Password
            </Button>
          ]}
        >
          {/* 🔹 NEW PASSWORD */}
          <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "4px" }}>
            New Password
          </div>
          <Input.Password
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
              setPasswordErrors((prev) => ({ ...prev, new_password: "" }));
            }}
          />
          {passwordErrors?.new_password && (
            <div style={{ color: "red", fontSize: "12px", marginBottom: "8px" }}>
              {passwordErrors.new_password}
            </div>
          )}

          {/* 🔹 CONFIRM PASSWORD */}
          <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "4px" }}>
            Confirm Password
          </div>
          <Input.Password
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              setPasswordErrors((prev) => ({ ...prev, confirm_password: "" }));
            }}
          />
          {passwordErrors?.confirm_password && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {passwordErrors.confirm_password}
            </div>
          )}
        </Modal>


      </Card>
    </div>
  );
}

export default Learners;
